import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-puntoapunto-local-campaign-conditions-modal',
  templateUrl: './puntoapunto-local-campaign-conditions-modal.component.html',
  styleUrls: ['./puntoapunto-local-campaign-conditions-modal.component.scss']
})
export class PuntoapuntoLocalCampaignConditionsModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
